/**
 * Created by hieult on 1/19/18.
 */
import * as types from '../constants/actionTypes';
import initialState from './initialState';
import * as constants from '../constants/constants';
import cloneDeep from 'lodash.clonedeep';

export default function navigationReducer(state = initialState.nav, action) {
  // **action**  will be of type: {"type": "Navigation/NAVIGATE", "routeName": SOME_ROUTE}
  // gets the new updated state of the navigator (previous state + new route), will return null if the action is not understandable.

  if (action.type.startsWith('Navigation/')) {
    const { type, routeName } = action;
    const lastRoute = state.navigationState.routes[state.navigationState.routes.length - 1];
    if (routeName === lastRoute.routeName) {
      return state;
    }
  }

  switch (action.type) {
    case types.RESET_SCREEN: {
      state = state.setIn(
        ['navigationState'],
        Object.assign(
          {},
          {
            index: 0,
            routes: [
              {
                routeName: action.screen,
              },
            ],
          }
        )
      );
      return state;
    }
    case types.INIT_ROUTES_SUCCESS: {
      const { data } = action;
      state = state.set('AppNavigator', data);
      return state;
    }

    case types.PUSH_SCREEN_SUCCESS: {
      const { routeName, params } = action;
      const oldState = cloneDeep(state);
      const getActionForPathAndParams = oldState.AppNavigator.router.getActionForPathAndParams(routeName);
      getActionForPathAndParams.params = params;
      const actionForPushScreen = oldState.AppNavigator.router.getStateForAction(getActionForPathAndParams, oldState.navigationState);
      return state.set('navigationState', actionForPushScreen);
    }

    case types.POP_SCREEN_SUCCESS: {
      const routes = [...state.navigationState.routes];
      let { index } = state.navigationState;
      if (index > 0) {
        routes.pop();
        index--;
      }
      state = state.setIn(['navigationState'], Object.assign({}, { index, routes }));
      return state;
    }

    case types.RESET_SCREEN_SUCCESS: {
      const { routeName, fromRouteName, params } = action;

      if (fromRouteName) {
        const actionForResetScreen = state.AppNavigator.router.getStateForAction(state.AppNavigator.router.getActionForPathAndParams(fromRouteName));
        state = state.set('navigationState', actionForResetScreen);
        const oldState = cloneDeep(state);
        const getActionForPathAndParams = oldState.AppNavigator.router.getActionForPathAndParams(routeName);
        const actionForPushScreen = oldState.AppNavigator.router.getStateForAction(getActionForPathAndParams, oldState.navigationState);
        return state.set('navigationState', actionForPushScreen);
      }
        const getActionForPathAndParams = state.AppNavigator.router.getActionForPathAndParams(routeName);
        getActionForPathAndParams.params = params;
        const actionForResetScreen = state.AppNavigator.router.getStateForAction(getActionForPathAndParams);
        return state.set('navigationState', actionForResetScreen);

    }
    default: {
      return state;
    }
  }
}
